module.exports = require("github:Robdel12/DropKick@2.1.7/lib/dropkick.js");